
    import { Vue, Component, Prop,  } from "vue-property-decorator";
  
    import UiButton from "@/components/button/ui-button.vue";
    import ContractorInvite from "@/components/contractors/ContractorInvite.vue";
    import PlusIcon from "@/components/icons/PlusIcon.vue";
  
  
    @Component({
      components: {
        UiButton,
        ContractorInvite,
        PlusIcon,
      },
    })
    export default class DashboardContractorInvite extends Vue {
      @Prop({type: String, required: true}) readonly companyId!: string;
      @Prop({type: String, required: true}) readonly currentUserId!: string;
      @Prop({type: String, required: true}) readonly companyBusinessName!: string;
      @Prop({type: String, default: "project"}) readonly size?: string;
      @Prop({ type: String, default: "Invite Contractors" }) readonly actionButtonContent!: string;
      @Prop({type: Boolean, default: false}) readonly isManager!: boolean;
  
      contractorDialog: boolean = false;
  
      showInviteModal(): void {
        this.contractorDialog = true;
      }
  
      get noCompany(): boolean {
        return !this.companyId;
      }
    }
  